import {
  PROJECT_ON_BOARD_XANO_PROJECTSLIST_BEGIN,
  PROJECT_ON_BOARD_XANO_PROJECTSLIST_SUCCESS,
  PROJECT_ON_BOARD_XANO_PROJECTSLIST_FAILURE,
  PROJECT_ON_BOARD_XANO_PROJECTSLIST_DISMISS_ERROR,
} from './constants';
import axios from 'axios';

export function xanoProjectslist(args = {}) {
  return (dispatch) => {
    dispatch({
      type: PROJECT_ON_BOARD_XANO_PROJECTSLIST_BEGIN,
    });

    const header = {
      headers: {
        Authorization: `Bearer ${args.token}`,
        'Content-Type': 'application/json',
      },
    };

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(`https://x8ki-letl-twmt.n7.xano.io/api:meta/workspace/${args.id}/table`, {
        headers: header.headers
      });
      doRequest.then(
        (res) => {
          dispatch({
            type: PROJECT_ON_BOARD_XANO_PROJECTSLIST_SUCCESS,
            data: res.data.items,
          });
          resolve(res);
        },

        (err) => {
          dispatch({
            type: PROJECT_ON_BOARD_XANO_PROJECTSLIST_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissXanoProjectslistError() {
  return {
    type: PROJECT_ON_BOARD_XANO_PROJECTSLIST_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PROJECT_ON_BOARD_XANO_PROJECTSLIST_BEGIN:
      return {
        ...state,
        xanoProjectslistPending: true,
        xanoProjectslistError: null,
      };

    case PROJECT_ON_BOARD_XANO_PROJECTSLIST_SUCCESS:
      return {
        ...state,
        xanoProjectslistPending: false,
        xanoProjectslistError: null,
        xanoProjectsData: action.data,
      };

    case PROJECT_ON_BOARD_XANO_PROJECTSLIST_FAILURE:
      return {
        ...state,
        xanoProjectslistPending: false,
        xanoProjectslistError: action.data.error,
      };

    case PROJECT_ON_BOARD_XANO_PROJECTSLIST_DISMISS_ERROR:
      return {
        ...state,
        xanoProjectslistError: null,
      };

    default:
      return state;
  }
}
